export interface AudioFile {
  path: string;
  artist?: string;
  title?: string;
}

interface AudioConfig {
  player1Files: AudioFile[];
  player2Files: AudioFile[];
}

export const audioConfig: AudioConfig = {
  player1Files: [
    { path: '/drones/Bleeps.m4a', artist: 'Yang', title: 'Bleeps' },
    { path: '/drones/Evelvair.m4a', artist: 'Yang', title: 'Evelvair' },
    { path: '/drones/In Slow Circles.m4a', artist: 'Mitch', title: 'In Slow Circles' },
    { path: '/drones/Lyra Drone.m4a', artist: 'Yang', title: 'Lyra Drone' },
    { path: '/drones/Miku.m4a', artist: 'Yang', title: 'Miku' },
    { path: '/drones/No Light Reaches Here.m4a', artist: 'Mitch', title: 'No Light Reaches Here' },
    { path: '/drones/Nothing Stays in Place.m4a', artist: 'Mitch', title: 'Nothing Stays in Place' },
    { path: '/drones/Peary Channel (First Trip).m4a', artist: 'jarreolog', title: 'Peary Channel (First Trip)' },
    { path: '/drones/Peary Channel (Second Trip).m4a', artist: 'jarreolog', title: 'Peary Channel (Second Trip)' },
    { path: '/drones/Peary Channel (Third Trip).m4a', artist: 'jarreolog', title: 'Peary Channel (Third Trip)' },
    { path: '/drones/SQ345.m4a', artist: 'Claudio', title: 'SQ345' },
    { path: '/drones/Slow Burn.m4a', artist: 'Claudio', title: 'Slow Burn' },
    { path: '/drones/Tine Machine.m4a', artist: 'Mitch', title: 'Tine Machine' }
  ],
  
  player2Files: [
    { path: '/field_recordings/Condo Pool and Birds.m4a', artist: 'Claudio', title: 'Condo Pool and Birds' },
    { path: '/field_recordings/Green Corridor South.m4a', artist: 'Madam Data', title: 'Green Corridor South' },
    { path: '/field_recordings/Green Line.m4a', artist: 'Claudio', title: 'Green Line' },
    { path: '/field_recordings/Outside Great World City.m4a', artist: 'Claudio', title: 'Outside Great World City' },
    { path: '/field_recordings/Rain in Admiralty Park.m4a', artist: 'Madam Data', title: 'Rain in Admiralty Park' },
    { path: '/field_recordings/Singapore Thunderstorm.m4a', artist: 'Rob', title: 'Singapore Thunderstorm' },
    { path: '/field_recordings/Tanah Merah Beach at Night.m4a', artist: 'Madam Data', title: 'Tanah Merah Beach at Night' },
    { path: '/field_recordings/Walk to MRT.m4a', artist: 'Claudio', title: 'Walk To MRT' },
    { path: '/field_recordings/pencil.m4a', artist: 'Sleepy Noon Radio', title: 'Pencil on Paper' }
  ]
};